export default __webpack_public_path__ + "static/media/NoResult.6d17657e.svg";